import React, { useState, useEffect, useRef } from "react";

import photo1 from "../assets/photos/2026/optimized/148A7174copy.jpg";
import photo2 from "../assets/photos/2026/optimized/148A7161copy.jpg";
import photo3 from "../assets/photos/2026/optimized/148A7546copy.jpg";
import photo4 from "../assets/photos/2026/optimized/148A7461copy.jpg";
import photo5 from "../assets/photos/2026/optimized/148A7207copy.jpg";

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const selectedPhotoRef = useRef(null);

  const handleOpen = (photo) => {
    setOpen(true);
    setSelectedPhoto(photo);
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
  };

  const handleClose = () => {
    // focus back on the photo that was clicked
    selectedPhotoRef.current?.focus();
    setOpen(false);
    setSelectedPhoto(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (dialogRef.current && open) {
      const handleClick = (e) => {
        if (dialogRef.current.contains(e.target)) {
          handleClose();
        }
      };

      // add escape key event listener
      const handleEscapeKey = (e) => {
        if (e.key === "Escape") {
          handleClose();
        }
      };

      document.addEventListener("click", handleClick);
      document.addEventListener("keydown", handleEscapeKey);

      return () => {
        document.removeEventListener("click", handleClick);
        document.removeEventListener("keydown", handleEscapeKey);
      };
    }
  }, [open]);

  return (
    <>
      <section className="gallery" data-colour="#c5dbf4">
        <ul className="gallery-photos">
          {Array.from({ length: 5 }, (_, i) => i + 1).map((i) => (
            <li key={i}>
              <img
                src={i === 1 ? photo1 : i === 2 ? photo2 : i === 3 ? photo3 : i === 4 ? photo4 : photo5}
                alt=""
                tabIndex={0}
                aria-label="View larger"
                ref={selectedPhoto === (i === 1 ? photo1 : i === 2 ? photo2 : i === 3 ? photo3 : i === 4 ? photo4 : photo5) ? selectedPhotoRef : null}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleOpen(i === 1 ? photo1 : i === 2 ? photo2 : i === 3 ? photo3 : i === 4 ? photo4 : photo5);
                  }
                }}
                onClick={() => handleOpen(i === 1 ? photo1 : i === 2 ? photo2 : i === 3 ? photo3 : i === 4 ? photo4 : photo5)}
              />
            </li>
          ))}
        </ul>

        {open && (
          <dialog className="gallery-dialog" ref={dialogRef} open={open}>
            <div className="gallery-dialog-content">
              <img src={selectedPhoto} alt="" />
            </div>
            <button
              onClick={handleClose}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleClose();
                }
              }}
              className="button dialog-close"
              ref={closeRef}
              aria-label="Dismiss"
            ></button>
          </dialog>
        )}
      </section>
    </>
  );
};

export { Gallery };
